import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { chf } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Check, Star } from "lucide-react";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { axios.get(`${API}/plans`).then(({ data }) => setPlans(data)); }, []);
  const feats = {
    FREE: ["1 espace mariage", "Jusqu'à 30 invités", "3 tables", "Budget de base", "Collaboration partenaire"],
    PREMIUM_MONTHLY: ["Invités illimités", "Plan de table complet", "RSVP avancé", "Assistant IA", "Exports & rapports"],
    PREMIUM_ANNUAL: ["Tout Premium", "2 mois offerts", "Site de mariage", "Collaborateurs", "Support prioritaire"],
    WEDDING_PASS: ["Accès complet", "Jusqu'après le mariage", "Un seul paiement", "Toutes les fonctionnalités"],
  };
  return (
    <div className="min-h-screen bg-background">
      <header className="h-20 flex items-center justify-between px-6 lg:px-12 max-w-7xl mx-auto">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-stone-900 flex items-center justify-center">
            <span className="text-champagne font-serif text-lg">A</span></div>
          <span className="font-serif text-lg">Notre Oui</span></Link>
        <Link to="/register"><Button className="rounded-full">Commencer</Button></Link>
      </header>
      <div className="max-w-6xl mx-auto px-6 py-14 text-center">
        <div className="eyebrow mb-3">Tarifs transparents · CHF</div>
        <h1 className="font-serif text-4xl lg:text-5xl">Choisissez votre formule</h1>
        <p className="text-stone-600 mt-4 max-w-xl mx-auto">Commencez gratuitement. Passez à Premium quand vous
          êtes prêt·e. Le Wedding Pass débloque tout jusqu'après votre mariage.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12 text-left">
          {plans.map((p) => (
            <div key={p.code} className={`card-lux p-6 flex flex-col relative ${p.recommended ? "ring-2 ring-champagne" : ""}`}
              data-testid={`plan-${p.code}`}>
              {p.recommended && <div className="absolute -top-3 left-6 bg-champagne text-stone-900 text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1">
                <Star className="w-3 h-3" /> Recommandé</div>}
              <div className="font-serif text-xl">{p.name}</div>
              <div className="mt-3"><span className="font-mono text-3xl">{p.amount === 0 ? "Gratuit" : chf(p.amount)}</span>
                {p.billing_type === "monthly" && <span className="text-stone-400 text-sm">/mois</span>}
                {p.billing_type === "yearly" && <span className="text-stone-400 text-sm">/an</span>}
                {p.billing_type === "one_time" && <span className="text-stone-400 text-sm"> unique</span>}</div>
              <p className="text-sm text-stone-500 mt-2 min-h-[40px]">{p.description}</p>
              <ul className="space-y-2 mt-4 flex-1">
                {(feats[p.code] || []).map((x) => (
                  <li key={x} className="flex items-start gap-2 text-sm text-stone-600">
                    <Check className="w-4 h-4 text-sage mt-0.5 flex-shrink-0" /> {x}</li>))}
              </ul>
              <Link to="/register" className="mt-6"><Button variant={p.recommended ? "default" : "outline"} className="w-full rounded-full">
                {p.amount === 0 ? "Commencer" : "Choisir"}</Button></Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
